import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { PurgeDetailsPopupComponent } from './purge-details-popup/purge-details-popup.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EditButton } from 'src/app/shared/common/Editbutton';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { IncrementalDataLoadSchedulePopupComponent } from '../baseline-data-load/incremental-data-load-schedule-popup/incremental-data-load-schedule-popup.component';
import { Schedulebutton } from 'src/app/shared/common/Schedulebutton';
import { TemplateReportButtons } from 'src/app/shared/common/template-report-buttons';
import { Purgebutton } from 'src/app/shared/common/purgebutton';
import { UserRoutingModule } from '../user-routing/user-routing.module';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';

@Component({
    selector: 'app-purge-details',
    templateUrl: './purge-details.component.html',
    styleUrls: ['./purge-details.component.scss'],
    standalone: false
})
export class PurgeDetailsComponent implements OnInit {
  gridAPI: any;
  gridColumnAPI: any;
  lastPage: boolean;
  currentPage: number;
  nextPage: number;
  nextPagePlusOne: number;
  totalPages: number;
  pageSize: number;
  getData: any = [];
  bootstrapColumn = 0;

  defaultColDef: any;
  columnDefs: any;
  dnsid:number;
  backgroundColorScreen: string;
  backgroundColorButton: string;
  components:any

  modifiedBy: string = '';
  status: any; 
 buttonIdList = []
  purgeData: any[] = [];
  buttonName: any;
  rowClassRules: { sick: (params: any) => boolean; };
  getRowStyle: (params: any) => { backgroundColor: string; };

  constructor(
    private commonService: CommonService,
    private dialog: MatDialog,
    private localStorage: LocalStorageSettingsService,
    private snackBar: MatSnackBar,
    private spinner:NgxUiLoaderService,
    private snackbar: MatSnackBar,
    private cdr: ChangeDetectorRef,
     private userRoutingModule: UserRoutingModule,
	   private reportLinkService:ReportlinksserviceService
  ) {
    this.components = {

      buttonRenderer: Purgebutton,

    };
  }

  ngOnInit(): void {

    	   let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorage.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.columnDefs = [
      {
        headerName: 'Action',
        filter: false,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
           values: this.buttonIdList,
          edit: this.editIcon.bind(this),
          delete: this.deleteIcon.bind(this),
          // addfilter: this.filterIcon.bind(this),
          addschedule: this.scheduleIcon.bind(this),
        },
        pinned: 'left',
        lockPinned: true,
        width: 180,
      },
      {
        headerName: 'Group Name',
        headerTooltip: 'Group Name',
        tooltipValueGetter: (params) => 'Group Name: ' + params.value,
        field: 'groupname',
        filter: 'agTextColumnFilter',
        width: 140
      },
      {
        headerName:'DnsId',
        headerToolTip:'DnsId',
        tooltipValueGetter:(params)=>
          'DnsId'+ params.value,
        field :'dnsid',
        filter:'agTextColumnFilter',
        width:80
  
      },
 
      {
        headerName:'Table Details',
        headerToolTip: 'Table Details',
        toolTipValueGetter:(params)=>
          'Table Details :' + params.value,
        field : 'tabledetails',
        filter:'agTextColumnFilter',
        width:180
  
      },
  
      {
        headerName: 'Retention Period',
        headerTooltip: 'Retention Period',
        tooltipValueGetter: (params) =>
          'Retention Period: ' + params.value,
        field: 'retention',
        filter: 'agTextColumnFilter',
        width: 120,
      },
      {
        headerName: 'State',
        headerTooltip: 'State',
        tooltipValueGetter: (params) =>
          'State : ' + params.value,
        field: 'state',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Is Active',
        headerTooltip: 'Is Active',
        tooltipValueGetter: (params) =>
          'Is Active : ' + params.value,
        field: 'isactive',
        filter: 'agTextColumnFilter',
        width: 180,
      },
  
      {
        headerName: 'Created By',
        headerTooltip: 'Created By',
        tooltipValueGetter: (params) =>
          'Createdby : ' + params.value,
        field: 'createdBy',
        filter: 'agTextColumnFilter',
        width: 180,
      },
  
      {
        headerName: 'Created Date And Time',
        headerTooltip: 'Created Date And Time',
        tooltipValueGetter: (params) =>
          'Created Date And Time : ' + params.value,
        field: 'createdatetime',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Last Modified Date And Time',
        headerTooltip: 'lastmodifieddatetime',
        tooltipValueGetter: (params) =>
          'Last Modified Date And Time : ' + params.value,
        field: 'lastmodifieddatetime',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Modified By',
        headerTooltip: 'modifiedBy',
        tooltipValueGetter: (params) =>
          'Modified By : ' + params.value,
        field: 'modifiedBy',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) =>
          'Status : ' + params.value,
        field: 'status',
        filter: 'agTextColumnFilter',
        width: 80,
      },
     
    ];

    this.rowClassRules = {
      "sick": function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
      

    };
    this.getRowStyle = (params: any) => {
      console.log(params)
      console.log(params.data.status)
      if (params.data.status === 'No') {
        return { backgroundColor: 'rgb(211, 211, 211)' }; // Inline style for deleted rows
      }
      // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
    };

    this.backgroundColorScreen = this.localStorage.getSettings('ColorD');
    this.backgroundColorButton = this.localStorage.getSettings('ColorA');
    // this. retrieveRecordsOfPurge();
  }

  /*
  Author- Venkata Shyam
  15-12-2024
  for opening the add record pop-up of purgedatails
*/

  openSaveForm(buttonName)  {
    console.log("opensaveform")
    var obj={}
    this.buttonName = buttonName;
    const dialogRef = this.dialog.open(PurgeDetailsPopupComponent, {
      panelClass: 'custom-dialog-container',
      width: "70%",
      autoFocus: false,
      maxWidth: '100vw',
      height: "85%",
      data: { edata: obj },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      this.retrieveRecordsOfPurge();
    });
    
  }

   /*
  Author- Venkata Shyam
  15-12-2024
  Implemented to retrieve the records of purge to display in the grid
*/
  customArray=[]
  retrieveRecordsOfPurge(){
    const tenantId = localStorage.getItem('dnsName');
    if (tenantId) {
      this.dnsid = parseInt(tenantId, 10); // Convert to integer with base 10
      if (isNaN(this.dnsid)) {
        console.error('Invalid tenantId in localStorage:', tenantId);
        
        return;
      }
      console.log(this.dnsid); // Outputs the number
      this.customArray = [];
      
    }
      this.customArray =[]
      this.commonService.retrieverecordsOfPurge(this.dnsid).subscribe(response => {
        if (response.error === true) {
          this.commonService.retrieverecordsOfPurge(this.dnsid).subscribe(response => {
            if (response.error === true) {
              this.spinner.stop();
              this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });
            } else {
              // Handle success scenario (e.g., updating the UI with records)
              console.log(response.data);
              // You can now use the response.data to populate your customArray
            }
          });
          this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });
        } else {
            console.log('This is the response from backend :',response)
            for (const item of response){
              this.customArray.push({
                groupname:item.groupname,
                dnsid:item.dnsid,
                tabledetails:item.tabledetails,
                keycolumn:item.keycolumn,
                retention:item.retentionperiod,
                state:item.state,
                isactive:item.isactive,
                createdBy:item.createdBy,
                createdatetime:item.createdDate,
                lastmodifieddatetime:item.lastModifiedDate,
                modifiedBy:item.lastModifiedBy,
                status:item.status,
                purgeid:item.purgeid,
              })
            }
            console.log(this.customArray);
        

            this.spinner.stop();
           
            console.log(response);
            console.log(response.data);
            console.log("gridAPI:", this.gridAPI);
           

            this.gridAPI.setGridOption('rowData', this.customArray);
            this.cdr.detectChanges();
        }
      });
  }


   /*
  Author- Venkata Shyam
  15-12-2024
  for opening the scheduler screen for purging the deletion task
*/
  scheduleIcon(event) {
    
    console.log(event);
    console.log(event.rowData.purgeid)
    if(event.rowData.status === "No"){
      this.snackbar.open("Selected record is already deleted","OK",{duration:5000});
      return;
    }
    console.log(event)
    console.log(event.rowData.purgeid);
    this.dialog.open(IncrementalDataLoadSchedulePopupComponent, {
      width: "80%",
      autoFocus: false,
      data: {purgeId: event.rowData.purgeid,scheduleFor:'Purging Data'},

      disableClose: true,

    });


  }

  resetForm(): void {
   
  }

   /*
  Author- Venkata Shyam
  15-12-2024
  for opening the edit record pop-up of purgedatails
*/
  editIcon(event){
  
    console.log(event)
    
    this.status = event.rowData.status;
    if(this.status === "Yes"){
      const dialogRef = this.dialog.open(PurgeDetailsPopupComponent, {
        panelClass: 'custom-dialog-container',
        width: "70%",
      autoFocus: false,
      maxWidth: '100vw',
      height: "85%",
        data: { editData: event.rowData,buttonName :'Update' },
        disableClose: true
       
      });
  
      dialogRef.afterClosed().subscribe(() => {
        this.retrieveRecordsOfPurge();
      });
      
    }
    else {
      this.snackbar.open(
        "Cannot edit purge data which is already deleted.",
        "OK",
        {
          duration: 8000,
        }
      );
    }

  }

   /*
  Author- Venkata Shyam
  15-12-2024
  Implemented to delete the record by making status as "No"
*/
  deleteIcon(event) {
   
    console.log(event);
    console.log(event.rowData.purgeid)
    if(event.rowData.status === "No"){
      this.snackbar.open("Selected record is already deleted","OK",{duration:5000});
      return;
    }
    if(confirm("Are you sure you want to delete this filter?")){
      this.spinner.start();
      this.commonService.deletePurge(event.rowData.purgeid).subscribe(result=>{
        if(result.statusMessage === "Successfully record is deleted"){
          this.snackbar.open(result.statusMessage, "OK",{duration:5000});
        }else{
          this.snackbar.open("Something went wrong and the record is not deleted", "OK",{duration:5000});
        }
        // const updatedRowData = this.customArray.map((item) => {
        //   if (item.purgeid === event.rowData.purgeid) {
        //     return { ...item, status: "No" }; // Update the status to 'No'
        //   }
        //   return item;
        // });
        this.customArray = this.customArray.filter(item => item.purgeid !== event.rowData.purgeid);
        // this.customArray = updatedRowData; // Update the array
        this.gridAPI.setGridOption('rowData', this.customArray);
        // this.refreshRun();
       
        this.spinner.stop();
      });
    }
    
  }

 
  
  refreshRun() {
    this.spinner.start();
    this.onGridReady(this.gridAPI);
    this.spinner.stop();
  }


  onPaginationChangedReturn(): void {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
      this.nextPage = this.currentPage + 1;
      this.nextPagePlusOne = this.currentPage + 2;
      this.totalPages = this.gridAPI.paginationGetTotalPages();
    }
  }

  onBtExport(): void {
    this.gridAPI.exportDataAsCsv();
  }

  onPaginationChanged(): void {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
      this.nextPage = this.currentPage + 1;
      this.nextPagePlusOne = this.currentPage + 2;
      this.totalPages = this.gridAPI.paginationGetTotalPages();
    }
  }

  onSearchChange(searchValue: number): void {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  onPageSizeChanged(newPageSize: number): void {
    this.gridAPI.setGridOption('paginationPageSize', Number(newPageSize));
  }

  onBtNext(): void {
    this.gridAPI.paginationGoToNextPage();
  }

  onBtPrevious(): void {
    this.gridAPI.paginationGoToPreviousPage();
  }

  onBtFirst(): void {
    this.gridAPI.paginationGoToFirstPage();
  }

  onBtLast(): void {
    this.gridAPI.paginationGoToLastPage();
  }

  onGridReady(params: any): void {
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    this.getData = [];
    this.retrieveRecordsOfPurge();
  }
}
